import { oz } from '@weft/utils';

export const HomePagePredictedMonthlyRevenueSchema = oz.object({
  month: oz.string().nonempty(),
  revenue: oz.number().nonnegative(),
}).openapi('HomePagePredictedMonthlyRevenue');

export type HomePagePredictedMonthlyRevenue = oz.infer<typeof HomePagePredictedMonthlyRevenueSchema>;
